import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';

import lodash from 'lodash';
import urlJoin from 'url-join';

@Injectable({
  providedIn: 'root',
})
export class APIService {
  public url(endpoint: string, vars = {}, query = {}) {
    // Replace url variables in endpoint
    Object.entries<any>(vars).forEach(([key, val]) => {
      // eslint-disable-next-line no-useless-escape
      const regex = new RegExp(`\{${key}\}`, 'g');
      endpoint = endpoint.replace(regex, val);
    });

    let queryString = this.generateQuery(query);
    queryString = queryString ? `?${queryString}` : '';

    return urlJoin(
      environment.API_URL,
      endpoint,
      '/',
      queryString,
    );
  }

  public generateQuery(query) {
    const params = new URLSearchParams();

    Object.entries<any>(query).forEach(([key, val]) => {
      lodash.concat(val).forEach((x) => params.append(key, x));
    });

    return params.toString();
  }

  public arrayToQueryValue(val: any[]) {
    return val ? val.join(',') : null;
  }

  public normalizeQuery(params: any) {
    const normalized = {};

    Object.entries<any>(params).forEach(([key, val]) => {
      normalized[key] = lodash.isArray(val) ?
        this.arrayToQueryValue(val) :
        val;
    });

    return normalized;
  }
}
